import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/media/images/logo_v1.png'


const _hoisted_1 = {
  class: "modal fade",
  id: "product_modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "product_modal"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "subscription-holder" }
const _hoisted_7 = { class: "subscription-main" }
const _hoisted_8 = { class: "subscription-widget card mb-10" }
const _hoisted_9 = { class: "image-holder" }
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  alt: "product image"
}
const _hoisted_11 = {
  key: 0,
  class: "text-end subscription-modal-price-cell"
}
const _hoisted_12 = {
  key: 1,
  class: "text-end"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "bi bi-cart-x"
}
const _hoisted_17 = { class: "ribbon-outofstock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: false
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h2", null, _toDisplayString(_ctx.$t('message.PRODUCTS')), 1),
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Table, {
                  columns: _ctx.columns,
                  rows: _ctx.products,
                  padding: 4
                }, {
                  "cell-image": _withCtx(({row:item}) => [
                    _createVNode("div", _hoisted_9, [
                      (item?.file_path)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: item?.file_path,
                            alt: "product image"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("img", _hoisted_10))
                    ])
                  ]),
                  "cell-name": _withCtx(({row:item}) => [
                    _createTextVNode(_toDisplayString(JSON.parse(item?.product_name)[_ctx.system_locale]?.name), 1)
                  ]),
                  "cell-price": _withCtx(({ row: rowItem, index: priceRowIndex }) => [
                    (rowItem?.available_stock > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode(_component_el_input_number, {
                            modelValue: _ctx.editedUnitPrices[priceRowIndex],
                            "onUpdate:modelValue": ($event: any) => (_ctx.editedUnitPrices[priceRowIndex] = $event),
                            min: 0,
                            precision: 2,
                            step: 0.01,
                            size: "small",
                            "controls-position": "right"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(rowItem?.special_price ? rowItem?.special_price : rowItem?.price), 1))
                  ]),
                  "cell-quantity": _withCtx(({ row: rowItem, index: qtyRowIndex }) => [
                    (rowItem?.available_stock > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_13, [
                          (rowItem?.multiple_limit == null && rowItem?.multiples == null)
                            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                _createVNode(_component_el_input_number, {
                                  modelValue: _ctx.number[qtyRowIndex],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.number[qtyRowIndex] = $event),
                                  min: 0
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_15, [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.number[qtyRowIndex],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.number[qtyRowIndex] = $event),
                                  onFocus: ($event: any) => (_ctx.cartLimit(rowItem?.multiple_limit, rowItem?.multiples)),
                                  size: "small",
                                  placeholder: "Select",
                                  class: "theme-select"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cartLimits, (opt) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: opt,
                                        label: opt,
                                        value: opt
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onFocus"])
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-actions": _withCtx(({ row: productRow, index }) => [
                    _createVNode("button", {
                      class: ["action-btn", productRow.available_stock < 1 ? 'opacity-50 pointer' : ''],
                      type: "button",
                      id: "action-trigger",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false",
                      onClick: ($event: any) => (productRow.inquiry_product ? _ctx.inquiryProduct() : _ctx.AddProduct(index, productRow))
                    }, [
                      (productRow.available_stock < 1)
                        ? (_openBlock(), _createBlock("i", _hoisted_16, [
                            _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('message.OUT_OF_STOCK')), 1)
                          ]))
                        : (_openBlock(), _createBlock("i", {
                            key: 1,
                            class: `bi ${productRow.inquiry_product ? 'bi-eye' : 'bi-cart2'}  cart-icon`
                          }, null, 2))
                    ], 10, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}